import styled from 'styled-components';

// Seed Sans' circled arrows (its ss03 glyphs), outlined from the Figma text
const PATHS = {
  increase:
    'M14.1749 28.35C6.33492 28.35 -7.80895e-05 22.015 -7.80895e-05 14.175C-7.80895e-05 6.33505 6.33492 4.69089e-05 14.1749 4.69089e-05C22.0149 4.69089e-05 28.3499 6.33505 28.3499 14.175C28.3499 22.015 22.0149 28.35 14.1749 28.35ZM12.5649 8.82005L10.9199 10.465H16.5199L8.64492 18.305L9.86992 19.53L17.7099 11.655V17.255L19.3549 15.645V8.82005H12.5649Z',
  decrease:
    'M14.1749 28.35C6.33492 28.35 -7.80895e-05 22.015 -7.80895e-05 14.175C-7.80895e-05 6.33505 6.33492 4.69089e-05 14.1749 4.69089e-05C22.0149 4.69089e-05 28.3499 6.33505 28.3499 14.175C28.3499 22.015 22.0149 28.35 14.1749 28.35ZM19.3199 12.705L17.6749 11.06V16.625L9.83492 8.78505L8.64492 9.97505L16.5199 17.85H10.8849L12.5299 19.495H19.3199V12.705Z',
};

// The viewBox is the design's 33×24 text box; the circle overflows it, as the glyph did
const Svg = styled.svg`
  flex-shrink: 0;
  color: var(--text-inverse-primary);

  /* Doubled class outranks the reset's svg:not(:root) { overflow: hidden } */
  && {
    overflow: visible;
  }

  /* A global * rule recolors the path, which would break currentColor */
  * {
    color: inherit;
  }
`;

interface CalloutArrowProps {
  direction: 'increase' | 'decrease';
}

const CalloutArrow = ({ direction }: CalloutArrowProps) => (
  <Svg width='33' height='24' viewBox='-2.333 1.425 33 24' aria-hidden='true'>
    <path d={PATHS[direction]} fill='currentColor' />
  </Svg>
);

export default CalloutArrow;
